import React from 'react';

const statuses = {
    'CAPTURED': {
        text: 'Capturado',
        color: 'success'
    },
    'AUTHORIZED': {
        text: 'Autorizado',
        color: 'info'
    },
    'CANCELATION_REQUESTED': {
        text: 'Estorno Solicitado',
        color: 'warning'
    },
    'PENDING_CANCELATION': {
        text: 'Estorno Autorizado',
        color: 'warning'
    },
    'CANCELLED': {
        text: 'Cancelada',
        color: 'danger'
    },
    'CHECKOUT_SUCCESS': {
        text: 'Finalizado',
        color: 'success'
    },
    'PAYMENT_INITIATED': {
        text: 'Pagamento Iniciado',
        color: 'info'
    },
    'UNCLASSIFIED': {
        text: 'Não Classificado',
        color: 'warning'
    },
    'SERVICE_UNAVAILABLE': {
        text: 'Serviço indisponivel',
        color: 'warning'
    },
    'VEHICLE_NOT_FOUND': {
        text: 'Veículo não encontrado',
        color: 'warning'
    },
    'VEHICLE_WITHOUT_DEBTS': {
        text: 'Veículo sem débitos',
        color: 'warning'
    },
    'SEARCH': {
        text: 'Consulta',
        color: 'info'
    },
    'CHECKOUT_FAIL': {
        text: 'Falha Pagamento',
        color: 'danger'
    },
    'SIMULATION': {
        text: 'Simulação',
        color: 'primary'
    },
    'UNKNOW': {
        text: 'Desconhecido',
        color: 'default'
    },
    'VEHICLE_NOT_FOUND': {
        text: 'Veículo não encontrado',
        color: 'default'
    },
    'SERVICE_UNAVAILABLE': {
        text: 'Detran indisponível',
        color: 'default'
    },
    'VEHICLE_WITHOUT_DEBTS': {
        text: 'Veículo sem débitos',
        color: 'default'
    }
}

const OrderStatusBadge = ({ status }) => {
    const st = statuses[status] || statuses['UNKNOW'];
    return (
        <span className={`badge badge-${st.color} mr-4`}>{st.text}</span>
    );
}

export default OrderStatusBadge;



// WEBPACK FOOTER //
// ./src/components/Shared/OrderStatusBadge.js